export default __webpack_public_path__ + "static/media/ding.34de1691.mp3";